import AddIcon from '@mui/icons-material/Add';
import { Box, FormHelperText, Icon, Tooltip } from '@mui/material';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { Button } from 'global/components/Button';
import Comment from 'global/components/comment';
import Form from 'global/components/form';
import { Row } from 'global/components/row';
import { Text } from 'global/components/text';
import { first, get } from 'global/lib/lodash';
import { formatDateFromNow } from 'global/utils/formatDate';
import { useEffect, useState } from 'react';
import { userHasPermissions } from 'redux/actions/userLogin';
import { useUser } from '../../hooks/useUser';
import { useStyles } from './styles';

export const CreateComment = (props) => {
  const { loading, onSubmitComment, onClose, commentState, setCommentState } = props;

  const classes = useStyles();

  const handleSubmitComment = () => {
    if (!loading) {
      onSubmitComment(commentState);
    }
  };

  const setFormState = (fs) => {
    setCommentState({ ...commentState, attributes: { ...get(commentState, 'attributes', {}), ...fs } });
  };

  const isready = get(commentState, 'attributes.body') && !(get(commentState, 'attributes.images', []) || []).find((i) => i.loading);

  return (
    <>
      <div className={classes.createCommentContainer}>
        <Form
          showAllScreens
          canSubmit={false}
          onFormState={setFormState}
          screens={[
            {
              title: 'Create Comment',
              inputs: [
                {
                  id: 'body',
                  type: 'TextField',
                  defaultValue: () => get(commentState, 'attributes.body', ''),
                  props: {
                    label: '',
                    rows: 5,
                    multiline: true,
                    placeholder: 'Enter your comment here...',
                  },
                },
                {
                  id: 'images',
                  type: 'DropArea',
                  defaultValue: () => get(commentState, 'attributes.images', ''),
                  props: {
                    notAllowed: ['tag'],
                    uploadAllNew: true,
                    collection: 'comment-images',
                    shouldUpdateOnCaptionChange: true,
                  },
                },
              ],
            },
          ]}
        />
      </div>
      <div className={classes.submitButtons}>
        <Button
          variant={'contained'}
          className={classes.cancelButton}
          startIcon={<Icon>close</Icon>}
          onClick={() => {
            setCommentState({});
            onClose();
          }}
        >
          Cancel
        </Button>

        <Tooltip title={props.commentDoneDisabled?.().text}>
          <span>
            <Button
              variant={'contained'}
              disabled={!isready && props.commentDoneDisabled?.().disabled}
              color="secondary"
              startIcon={<Icon>check</Icon>}
              onClick={handleSubmitComment}
              loading={loading}
            >
              Done
            </Button>
          </span>
        </Tooltip>
      </div>
    </>
  );
};

const CommentContainer = (props) => {
  const { loading, comments, showCreateComment, onShowCreateComment, labelText, helperText } = props;
  const [currentCommentTab, setCurrentCommentTab] = useState('comment');
  const classes = useStyles();
  const uhook = useUser();
  const { me } = uhook;
  const hasComments = get(comments, 'data.length', 0) > 0;
  const commentDates = () => {
    return `last updated ${formatDateFromNow(get(first(comments), 'createdAt', new Date()))}`;
  };

  useEffect(() => {
    if (showCreateComment && document.getElementById('create-comment')) {
      document.getElementById('create-comment').scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }, [showCreateComment]);

  const handleCommentDeleted = (id) => {
    comments.update();
  };

  return (
    <div className={classes.commentContainer}>
      <div className={classes.commentWrapTitle}>
        <Text type="title_large">
          <strong>{labelText || 'Activity'}</strong>
        </Text>
        {hasComments && <div className={classes.commentCount}>{commentDates()}</div>}
      </div>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
      {hasComments && (
        <>
          <div className={classes.showWrap}>
            <Row>
              <Text>Show: </Text>
              <ToggleButtonGroup color="secondary" size="small" value={currentCommentTab} onChange={(e, v) => setCurrentCommentTab(v)} exclusive={true}>
                <ToggleButton value="all">All</ToggleButton>
                <ToggleButton value="comment">Comments</ToggleButton>
                <ToggleButton value="history">History</ToggleButton>
              </ToggleButtonGroup>
            </Row>
          </div>
          {comments.data?.map((c, i) => (
            <Comment key={i} {...c} user={me} isAdmin={userHasPermissions(['manageAccount'])} onDeleted={() => handleCommentDeleted(c.id)} />
          ))}
        </>
      )}

      <Box id="create-comment" className={classes.paddingTopBottom}>
        {showCreateComment ? (
          <CreateComment
            loading={loading}
            onClose={() => {
              onShowCreateComment(false);
            }}
            {...props}
          />
        ) : (
          <Box display="flex" justifyContent="flex-end">
            <Button
              startIcon={<AddIcon />}
              onClick={() => {
                onShowCreateComment(true);
              }}
            >
              Comment
            </Button>
          </Box>
        )}
      </Box>
    </div>
  );
};

export default CommentContainer;
